import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { useInputWrapperContext } from "./auth-service-tools304.js";

function InputsGroupFieldset(_ref) {
  let {
    children,
    role
  } = _ref;
  const ctx = useInputWrapperContext();

  if (!ctx) {
    return /* @__PURE__ */jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
      children
    });
  }

  return /* @__PURE__ */jsxRuntimeExports.jsx("div", {
    role,
    "aria-labelledby": ctx.labelId,
    "aria-describedby": ctx.describedBy,
    children
  });
}

export { InputsGroupFieldset };